
import { OnboardingState } from "./types";
import { buyTwilioNumberEdge, configureVoiceWebhooksEdge } from "@/integrations/supabase/twilioApi";


export function useOnboardingTransitions(onboarding: OnboardingState | null, patch: (updates: Partial<OnboardingState>) => Promise<boolean>) {
  const buyNumber = async (areaCode: string) => {
    if (!onboarding) return false;
    try {
      await buyTwilioNumberEdge(areaCode);
      await patch({
        first_number_added_at: new Date().toISOString(),
        current_step: "forward",
      });
      return true;
    } catch (e) {
      console.error("Failed to buy number:", e);
      return false;
    }
  };

  const saveForwarding = async (forwardingNumber: string) => {
    if (!onboarding) return;
    
    try {
      // Configure voice webhooks for existing numbers
      await configureVoiceWebhooksEdge();
    } catch (err) {
      console.warn("Failed to configure voice webhooks:", err);
      // Continue anyway, this isn't critical for the forwarding step
    }
    
    await patch({
      forwarding_number: forwardingNumber,
      current_step: "recording",
    });
  };

  const saveRecordingPrefs = async (recordingEnabled: boolean, retention: number) => {
    if (!onboarding) return;
    await patch({
      recording_enabled: recordingEnabled,
      retention_days: retention,
      current_step: "dni",
    });
  };

  const markComplete = async () => {
    if (!onboarding) return;
    await patch({
      onboarding_completed_at: new Date().toISOString(),
      current_step: "done",
      dni_snippet_generated: true,
    });
  };

  return { buyNumber, saveForwarding, saveRecordingPrefs, markComplete };
}
